/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

// Browser UTC offset in hours (e.g. -3 for America/Sao_Paulo), matching how the native
// Chatwoot reports send it. The backend buckets days in this timezone so the report's
// day axis follows the viewer's local day rather than UTC.
const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

// The computed browser offset always wins: spread the caller params first so a stale or
// caller-supplied timezone_offset can't override the real local offset.
const withTimezone = (params = {}) => ({
  ...params,
  timezone_offset: getTimeOffset(),
});

class KanbanReportsAPI extends ApiClient {
  constructor() {
    super('kanban/reports', { accountScoped: true, apiVersion: 'v1' });
  }

  summary(params = {}) {
    return axios.get(`${this.url}/summary`, { params: withTimezone(params) });
  }

  timeseries(params = {}) {
    return axios.get(`${this.url}/timeseries`, {
      params: withTimezone(params),
    });
  }

  funnel(params = {}) {
    return axios.get(`${this.url}/funnel`, { params: withTimezone(params) });
  }

  cfd(params = {}) {
    return axios.get(`${this.url}/cfd`, { params: withTimezone(params) });
  }

  aging(params = {}) {
    return axios.get(`${this.url}/aging`, { params: withTimezone(params) });
  }

  agentPerformance(params = {}) {
    return axios.get(`${this.url}/agent_performance`, {
      params: withTimezone(params),
    });
  }

  stageDurations(params = {}) {
    return axios.get(`${this.url}/stage_durations`, {
      params: withTimezone(params),
    });
  }

  // Fetches the CSV variant of a report (the download button). `report` is the endpoint
  // segment (e.g. 'summary', 'agent_performance') and resolves the .csv text body.
  download(report, params = {}) {
    return axios
      .get(`${this.url}/${report}.csv`, { params: withTimezone(params) })
      .then(response => response.data);
  }
}

export default new KanbanReportsAPI();
